import { render, staticRenderFns } from "./OrderShipment.vue?vue&type=template&id=285c42ea"
import script from "./OrderShipment.vue?vue&type=script&lang=js"
export * from "./OrderShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports